import { render, staticRenderFns } from "./studyPage.vue?vue&type=template&id=60ce4b48&scoped=true&"
import script from "./studyPage.vue?vue&type=script&lang=js&"
export * from "./studyPage.vue?vue&type=script&lang=js&"
import style0 from "./studyPage.vue?vue&type=style&index=0&id=60ce4b48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce4b48",
  null
  
)

export default component.exports